import styles from "../styles/SignInButton.module.css";
// import Loader from "./Loader";
import { FaApple } from "react-icons/fa";
import useTranslation from "next-translate/useTranslation";

export default function AppleButton({ text, size = null, onClick }) {
  const { t } = useTranslation("common");
  // const [loading, setLoading] = useState(false);

  // function handleOnClick() {
  //   setLoading(true);

  //   setTimeout(() => {
  //     onClick();
  //   }, 100);
  // }

  const sizeStyle =
    size === "small" ? styles.appleButtonSmall : styles.appleButton;

  return (
    <div className={sizeStyle} onClick={(e) => onClick()}>
      <FaApple />
      <div className={styles.signInButtonText}>{t(text)}</div>
      {/* {loading && (
        <span style={{ marginLeft: "7px" }}>
          <Loader color="white" />
        </span>
      )} */}
    </div>
  );
}


